// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"390de303","787":"227463f2"}[chunkId] + ".chunk.js";
};